import { createContext, useContext } from 'react'
import useOnlineStatus from '../../hooks/useOnlineStatus'

const OnlineContext = createContext()

const useOnlineContext = () => useContext(OnlineContext)

const OnlineContextProvider = ({ children }) => {
  const { isOnline, onDataStoreSync } = useOnlineStatus()

  return (
    <OnlineContext.Provider
      value={{
        isOnline,
        onDataStoreSync
      }}
    >
      {children}
    </OnlineContext.Provider>
  )
}

export default OnlineContextProvider

export { useOnlineContext }
